import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Video, { IVideoProps } from 'tbk-components/src/components/Video';

export interface ILifeAtCalianProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Description
	 * @control richtext
	 */
	description?: string;
	/**
	 * Toggle to Show Images - Default is to show images
	 */
	showImages?: boolean;
	/**
	 * Image One - Recommended Size: 382px x 382px
	 */
	imageOne?: IImage;
	/**
	 * Image Two - Recommended Size: 287px x 382px
	 */
	imageTwo?: IImage;
	/**
	 * Video Properties
	 */
	video?: IVideoProps;
}

/**
 * Calian Life at Calian Component
 * @block
 * @icon media-document
 */
const LifeAtCalian: React.FC<ILifeAtCalianProps> = ({
	id,
	className,
	classNames = [],
	heading,
	description,
	showImages = true,
	imageOne,
	imageTwo,
	video,
}) => (
	<div
		id={id}
		className={className || cn('calian-life-at-calian', ...classNames)}
	>
		<div className="calian-life-at-calian__container container-fluid">
			<div className="row">
				<div className="calian-life-at-calian__top col-12">
					{showImages && (
						<div className="calian-life-at-calian__image-container">
							{imageOne && (
								<div className="calian-life-at-calian__image-one">
									<Image
										{...imageOne}
										className="img-fluid"
									/>
								</div>
							)}
							{imageTwo && (
								<div className="calian-life-at-calian__image-two">
									<Image
										{...imageTwo}
										className="img-fluid"
									/>
								</div>
							)}
						</div>
					)}
					{((video.url && video.url.src) || video.oembed != '') && (
						<div className="calian-life-at-calian__video-container">
							<Video {...video} />
						</div>
					)}
				</div>
				<div className="calian-life-at-calian__bottom col-12">
					<div className="calian-life-at-calian__content">
						{heading && (
							<h3 className="calian-life-at-calian__heading">
								{heading}
							</h3>
						)}
						{description && (
							<div
								className="calian-life-at-calian__description"
								dangerouslySetInnerHTML={{
									__html: description,
								}}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default LifeAtCalian;
